module.exports = __webpack_public_path__ + "img/arrow-up-new.18a2ff4a.svg";